<template>
  <v-container
    :key="pageKey"
    fluid
    style="
      background: rgba(255, 255, 255, 0.9);
      min-width: 100%;
      min-height: 95vh;
      padding: 10px 20px;
      position: relative;
    "
  >
    <h6
      @click="closePage"
      style="
        border: 1px solid rgba(0, 0, 0, 0.3);
        border-radius: 5px;
        position: absolute;
        padding-top: 2px;
        width: 90px;
        cursor: pointer;
        z-index: 4;
      "
    >
      <v-icon style="position: relative; top: -1px">mdi-chevron-left</v-icon
      >kembali
    </h6>
    <div style="margin: 25px 0 65px 0">
      <div
        style="position: sticky; top: 55px; z-index: 3; background-color: white"
      >
        <div style="border-bottom: 1px solid rgba(0, 0, 0, 0.2)">
          <div
            class="d-flex justify-start align-start"
            style="position: relative"
          >
            <h4 class="fpb-title mb-2">DETAIL PENERIMAAN BARANG</h4>
            <v-tooltip bottom color="grey">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  x-small
                  text
                  icon
                  color="grey darken-2"
                  @click="loadPage"
                  style="position: relative; top: 12px"
                >
                  <v-icon small>mdi-refresh</v-icon>
                </v-btn>
              </template>
              <span>refresh page</span>
            </v-tooltip>
            <v-spacer></v-spacer>
            <div class="actionButton" v-if="detail != null">
              <!-- Admin -->

              <div>
                <div v-if="getUserProfile.employee.id == detail.employee_id">
                  <v-btn
                    v-if="detail.status == 0 && isEdit"
                    @click.prevent="saveChange"
                    type="button"
                    elevation="0"
                    color="primary"
                    class="white--text font-weight-bold ma-1"
                    style="font-size: 12px"
                    :loading="loading"
                    small
                    :rounded="wWidth < 809"
                  >
                    Save
                  </v-btn>
                  <v-btn
                    v-if="detail.status == 0 && !isEdit"
                    type="button"
                    elevation="0"
                    color="primary"
                    class="white--text font-weight-bold ma-1"
                    style="font-size: 12px"
                    @click.prevent="editDetail"
                    :loading="loading"
                    small
                    :rounded="wWidth < 809"
                  >
                    Edit
                  </v-btn>
                  <v-btn
                    v-if="detail.status == 0 && !isEdit"
                    type="button"
                    elevation="0"
                    color="green"
                    class="white--text font-weight-bold ma-1"
                    style="font-size: 12px"
                    :loading="loading"
                    :disabled="loading"
                    small
                    :rounded="wWidth < 809"
                    @click.prevent="submitGr"
                  >
                    Submit
                  </v-btn>
                  <v-btn
                    v-if="detail.status === 2"
                    type="button"
                    elevation="0"
                    color="primary"
                    class="white--text font-weight-bold ma-1"
                    style="font-size: 12px"
                    @click.prevent="setDraftGr"
                    :loading="loading"
                    :disabled="loading"
                    small
                    :rounded="wWidth < 809"
                  >
                    Set Draft
                  </v-btn>

                  <v-btn
                    v-if="!isEdit && detail.status != 2"
                    type="button"
                    elevation="0"
                    color="pink"
                    class="white--text font-weight-bold ma-1"
                    style="font-size: 12px"
                    :loading="loading"
                    :disabled="loading"
                    small
                    @click.prevent="cancelGr"
                    :rounded="wWidth < 809"
                  >
                    Cancel GR
                  </v-btn>
                  <v-btn
                    v-if="isEdit"
                    type="button"
                    elevation="0"
                    color="pink"
                    class="white--text font-weight-bold ma-1"
                    style="font-size: 12px"
                    @click.prevent="isEdit = !isEdit"
                    :loading="loading"
                    :disabled="loading"
                    small
                    :rounded="wWidth < 809"
                  >
                    Cancel Edit
                  </v-btn>
                </div>
                <!-- <div v-if="isAllow"> -->
                <!-- <div v-if="detail.status == 1"> -->
                <!-- <div
                    v-if="
                      detail.approver_users.find(
                        (e) => e === getUserProfile.employee.email
                      ) === undefined
                    "
                  > -->
                <!-- <v-btn
                  type="button"
                  elevation="0"
                  color="green"
                  class="white--text font-weight-bold ma-1"
                  style="font-size: 12px"
                  :loading="loading"
                  :disabled="loading"
                  small
                  :rounded="wWidth < 809"
                  @click="confirmPayreq"
                >
                  Confirm
                </v-btn>
                <v-btn
                  type="button"
                  elevation="0"
                  color="pink"
                  class="white--text font-weight-bold ma-1"
                  style="font-size: 12px"
                  :loading="loading"
                  :disabled="loading"
                  small
                  :rounded="wWidth < 809"
                  @click="rejectPayreq"
                >
                  Reject
                </v-btn> -->
                <!-- </div> -->
                <!-- </div> -->
                <!-- </div> -->
                <!-- <div
                  v-if="
                    getUserProfile.level.find(({ id }) => id === '3') !==
                    undefined
                  "
                  class="d-flex"
                > -->

                <!-- </div> -->
              </div>
            </div>
          </div>
        </div>
        <v-row no-gutters v-if="detail != null">
          <v-col cols="4">
            <p style="font-size: 12px">
              Tgl. Pembuatan: {{ convertDate(detail.createdAt) }} |
              {{ detail.created_by_name }}
            </p>
          </v-col>
          <!-- <v-col cols="4">
          <p style="font-size: 12px">
            Tgl. Terima: {{ convertDate(detail.received_date) }} |
            {{ detail.received_by_name }}
          </p>
        </v-col> -->
          <v-col cols="8">
            <div class="d-flex justify-end">
              <p
                :style="`background-color: ${statusColor(detail.status)};
                color: white;
                font-weight: bold;
                margin: 5px 0 0 0;
                padding: 0 10px;
                border: 1px solid rgba(0, 0, 0, 0.6);
                width: 180px;
                text-align: center;`"
              >
                {{ statusName(detail.status) }}
              </p>
            </div>
          </v-col>
        </v-row>
      </div>
      <v-row v-if="detail != null" no-gutters style="margin-top: 40px">
        <v-col cols="12" md="3" class="d-flex flex-column pl-3 pr-3">
          <p
            class="text-left"
            style="
              margin: 0;
              font-size: 12px;
              font-weight: bold;
              color: rgba(0, 0, 0, 0.5);
            "
          >
            No. Dokumen
          </p>

          <v-text-field
            :value="detail.document_no"
            dense
            readonly
            style="font-size: 12px; height: 45px"
          />
        </v-col>
        <v-col cols="12" md="3" class="d-flex flex-column pl-3 pr-3">
          <p
            class="text-left"
            style="
              margin: 0;
              font-size: 12px;
              font-weight: bold;
              color: rgba(0, 0, 0, 0.5);
            "
          >
            PIC
          </p>

          <v-text-field
            :value="detail.employee_name"
            dense
            readonly
            style="font-size: 12px; height: 45px"
          />
        </v-col>
        <v-col cols="12" md="3" class="d-flex flex-column pl-3 pr-3">
          <p
            class="text-left"
            style="
              margin: 0;
              font-size: 12px;
              font-weight: bold;
              color: rgba(0, 0, 0, 0.5);
            "
          >
            Perusahaan
          </p>

          <v-text-field
            :value="detail.company_name"
            dense
            readonly
            style="font-size: 12px; height: 45px"
          />
        </v-col>
        <v-col cols="12" md="3" class="d-flex flex-column pl-3 pr-3">
          <p
            class="text-left"
            style="
              margin: 0;
              font-size: 12px;
              font-weight: bold;
              color: rgba(0, 0, 0, 0.5);
            "
          >
            Department
          </p>

          <v-text-field
            :value="detail.department_name"
            dense
            readonly
            style="font-size: 12px; height: 45px"
          />
        </v-col>

        <v-col cols="12" md="3" class="d-flex flex-column pl-3 pr-3">
          <p
            class="text-left"
            style="
              margin: 0;
              font-size: 12px;
              font-weight: bold;
              color: rgba(0, 0, 0, 0.5);
            "
          >
            Diterima dari
          </p>

          <v-text-field
            :value="detail.received_from_vendor_name"
            readonly
            dense
            style="font-size: 12px; height: 45px"
          />
        </v-col>
        <v-col cols="12" md="3" class="d-flex flex-column pl-3 pr-3">
          <p
            class="text-left"
            style="
              margin: 0;
              font-size: 12px;
              font-weight: bold;
              color: rgba(0, 0, 0, 0.5);
            "
          >
            Diserahkan Oleh
          </p>

          <v-text-field
            v-model="detail.submitted_by_name"
            :outlined="isEdit"
            :clearable="isEdit"
            :readonly="!isEdit"
            dense
            style="font-size: 12px; height: 45px"
          />
        </v-col>
        <v-col cols="12" md="3" class="d-flex flex-column pl-3 pr-3">
          <p
            class="text-left"
            style="
              margin: 0;
              font-size: 12px;
              font-weight: bold;
              color: rgba(0, 0, 0, 0.5);
            "
          >
            Diterima Oleh
          </p>

          <v-text-field
            v-model="detail.received_by_name"
            :outlined="isEdit"
            :clearable="isEdit"
            :readonly="!isEdit"
            dense
            style="font-size: 12px; height: 45px"
          />
        </v-col>
        <v-col cols="12" md="3" class="d-flex flex-column pl-3 pr-3">
          <p
            class="text-left"
            style="
              margin: 0;
              font-size: 12px;
              font-weight: bold;
              color: rgba(0, 0, 0, 0.5);
            "
          >
            Tanggal terima
          </p>

          <v-text-field
            v-model="detail.received_date"
            :outlined="isEdit"
            :clearable="isEdit"
            :readonly="!isEdit"
            type="date"
            step="1"
            dense
            style="font-size: 12px; height: 45px"
          />
        </v-col>
        <v-col cols="12" md="3" class="d-flex flex-column pl-3 pr-3">
          <p
            class="text-left"
            style="
              margin: 0;
              font-size: 12px;
              font-weight: bold;
              color: rgba(0, 0, 0, 0.5);
            "
          >
            No. FPB
            <v-tooltip right color="info">
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  @click="openDetailFpb(detail.purchase_request)"
                  style="cursor: pointer"
                  x-small
                  color="primary"
                >
                  mdi-open-in-new
                </v-icon>
              </template>
              <span>Lihat detail FPB</span>
            </v-tooltip>
          </p>

          <v-text-field
            :value="
              detail.purchase_request != null
                ? detail.purchase_request.request_no
                : '-'
            "
            dense
            readonly
            style="font-size: 12px; height: 45px"
          />
        </v-col>

        <!-- <v-col cols="12" md="3" class="d-flex flex-column pl-3 pr-3">
          <p
            class="text-left"
            style="
              margin: 0;
              font-size: 12px;
              font-weight: bold;
              color: rgba(0, 0, 0, 0.5);
            "
          >
            No. terima
          </p>

          <v-text-field
            v-model="detail.received_no"
            :outlined="isEdit"
            :clearable="isEdit"
            :readonly="!isEdit"
            dense
            style="font-size: 12px; height: 45px"
          />
        </v-col> -->

        <v-col cols="12" md="3" class="d-flex flex-column pl-3 pr-3">
          <p
            class="text-left"
            style="
              margin: 0;
              font-size: 12px;
              font-weight: bold;
              color: rgba(0, 0, 0, 0.5);
            "
          >
            No. PO
          </p>

          <v-text-field
            v-model="detail.po_no"
            :outlined="isEdit"
            :clearable="isEdit"
            :readonly="!isEdit"
            dense
            style="font-size: 12px; height: 45px"
          />
        </v-col>
        <v-col cols="12" md="3" class="d-flex flex-column pl-3 pr-3">
          <p
            class="text-left"
            style="
              margin: 0;
              font-size: 12px;
              font-weight: bold;
              color: rgba(0, 0, 0, 0.5);
            "
          >
            No. Surat Jalan Vendor
          </p>

          <v-text-field
            v-model="detail.sj_no"
            :outlined="isEdit"
            :clearable="isEdit"
            :readonly="!isEdit"
            dense
            style="font-size: 12px; height: 45px"
          />
        </v-col>

        <v-col
          v-if="detail.status == 2"
          cols="12"
          class="d-flex flex-column pl-3 pr-3"
        >
          <p
            class="text-left"
            style="
              margin: 0;
              font-size: 12px;
              font-weight: bold;
              color: rgb(250, 0, 0);
            "
          >
            Alasan Cancel
          </p>
          <v-textarea
            :value="detail.canceled_reason"
            dense
            :auto-grow="true"
            rows="1"
            disabled
            color="red"
            clear-icon="mdi-close-circle"
          ></v-textarea>
        </v-col>
        <!-- <v-col cols="12" md="3" class="d-flex flex-column pl-3 pr-3">
          <p
            class="text-left"
            style="
              margin: 0;
              font-size: 12px;
              font-weight: bold;
              color: rgba(0, 0, 0, 0.5);
            "
          >
            No. Form
          </p>

          <v-text-field
            v-model="detail.form_no"
            :outlined="isEdit"
            :clearable="isEdit"
            :readonly="!isEdit"
            dense
            style="font-size: 12px; height: 45px"
          />
        </v-col> -->
      </v-row>
      <v-card v-if="detail != null" style="margin-top: 10px">
        <v-tabs
          v-model="tab"
          background-color="rgb(240,240,240)"
          slider-color="primary"
          color="primary"
        >
          <v-tab v-for="item in items" :key="item.tab">
            {{ item.tab }}
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <v-tab-item
            v-for="item in items"
            :key="item.tab"
            style="padding: 20px"
          >
            <div style="min-height: 60vh">
              <div v-if="item.tab == 'Detail Barang'">
                <v-data-table
                  v-model="selectedData"
                  :loading="loading"
                  height="30vh"
                  mobile-breakpoint="0"
                  :dense="wWidth > 808 ? true : false"
                  style="cursor: pointer; border: 1px solid rgba(0, 0, 0, 0.2)"
                  :headers="grHeaders"
                  :items="detail.goods_receipt_detail"
                  :items-per-page="10"
                  @click:row="rowClick"
                  :search="searchItem"
                  :custom-filter="customSearch"
                  :options.sync="options"
                  :show-select="
                    getUserProfile.level.find(({ id }) => id === '41') ===
                      undefined && detail.status == 0
                  "
                  item-key="id"
                >
                  <template v-slot:top>
                    <div
                      style="
                        border: thin solid rgba(0, 0, 0, 0.12);
                        cursor: auto;
                        padding: 0 15px;
                        height: 75px;
                        display: flex;
                        overflow: hidden;
                      "
                    >
                      <div
                        style="
                          display: flex;
                          align-items: center;
                          margin: 0 15px 0 5px;
                        "
                      >
                        <v-btn
                          v-if="detail.status == 0"
                          @click="openItemForm"
                          style="font-size: 10px"
                          elevation="2"
                          tilerounded="5px"
                          x-small
                          color="primary"
                          class="white--text"
                        >
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on" small class="">
                                mdi-plus
                              </v-icon>
                            </template>
                            <span>Tambah item</span>
                          </v-tooltip>
                        </v-btn>
                      </div>
                      <div style="width: 120px">
                        <v-select
                          :disabled="selectedData.length === 0"
                          label="Action"
                          style="
                            position: relative;
                            top: 15px;
                            margin: 0 15px 0 5px;
                            font-size: 12px;
                          "
                          v-model="actionValue"
                          :items="itemsAction"
                          item-text="name"
                          item-value="id"
                          outlined
                          return-id
                          dense
                          @change="actionSelect"
                        ></v-select>
                      </div>
                      <div
                        style="
                          width: 260px;
                          position: relative;
                          top: 15px;
                          margin: 0 15px 0 5px;
                          font-size: 12px;
                          height: 45px;
                        "
                      >
                        <v-text-field
                          v-model="searchItem"
                          label="Cari barang"
                          outlined
                          dense
                        ></v-text-field>
                      </div>
                      <v-spacer></v-spacer>
                      <div style="display: flex; align-items: center">
                        <v-btn
                          elevation="0"
                          color="transparent"
                          small
                          outlined
                          style="margin-right: 10px"
                          :loading="loading"
                          @click="downloadDokumen"
                        >
                          <v-icon
                            color="primary"
                            small
                            style="margin-right: 5px"
                            >mdi-file-outline</v-icon
                          >
                          <a href="#" style="font-weight: bold"
                            >File Pendukung</a
                          >
                        </v-btn>
                        <v-btn
                          elevation="0"
                          color="transparent"
                          small
                          outlined
                          style="margin-right: 10px"
                          :loading="loading"
                          @click="generatePdfGr"
                        >
                          <v-icon
                            color="primary"
                            small
                            style="margin-right: 5px"
                            >mdi-magnify
                          </v-icon>
                          <a href="#" style="font-weight: bold">Lihat PDF</a>
                        </v-btn>
                      </div>
                    </div>
                  </template>
                  <template v-slot:[`item.no`]="{ index }">
                    <div style="width: 35px">
                      {{ index + 1 }}
                    </div>
                  </template>
                  <template v-slot:[`item.payment_request`]="{ item }">
                    <div style="width: 145px; font-size: 12px">
                      {{
                        item.payment_request != null
                          ? item.payment_request.document_no
                          : '-'
                      }}
                    </div>
                  </template>
                  <template v-slot:[`item.product_code`]="{ item }">
                    <div style="width: 95px; font-size: 12px">
                      {{ item.product.code }}
                    </div>
                  </template>
                  <template v-slot:[`item.product_name`]="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <div
                          v-bind="attrs"
                          v-on="on"
                          style="
                            text-align: left;
                            width: 250px;
                            font-size: 12px;
                            padding: 0;
                          "
                        >
                          {{
                            `${
                              item.product.code !== null
                                ? '(' + item.product.code + ')'
                                : ''
                            } ${item.product.name}`
                          }}
                        </div>
                      </template>
                      <span>
                        {{
                          `${
                            item.product.code !== null
                              ? '(' + item.product.code + ')'
                              : ''
                          } ${item.product.name}`
                        }}</span
                      >
                    </v-tooltip>
                  </template>
                  <!-- <template v-slot:[`item.qty_return`]="{ item }">
                    <div style="width: 45px; font-size: 12px">
                      {{ item.qty_return }}
                    </div>
                  </template> -->
                  <template v-slot:[`item.uom_name`]="{ item }">
                    <div style="width: 35px; font-size: 12px">
                      {{ item.uom_name }}
                    </div>
                  </template>
                  <!-- <template v-slot:[`item.qty_request`]="{ item }">
                    <div style="width: 50px; font-size: 12px">
                      {{ item.qty_request }}
                    </div>
                  </template> -->
                  <template v-slot:[`item.qty_done`]="{ item }">
                    <div style="width: 50px; font-size: 12px">
                      {{ item.qty_done }}
                    </div>
                  </template>
                  <template v-slot:[`item.description`]="{ item }">
                    <div style="width: 215px; font-size: 12px">
                      {{ item.description }}
                    </div>
                  </template>
                </v-data-table>
              </div>
            </div>
          </v-tab-item>
        </v-tabs-items>

        <div
          v-if="isEdit"
          style="
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.1);
          "
        ></div>
      </v-card>
    </div>
    <div>
      <FormItemGr
        :act="act"
        :detail="detail"
        :itemDetail="itemDetail"
        :proc="proc"
        @loadPage="loadPage"
      />
    </div>
    <v-snackbar
      top
      elevation="0"
      color="white"
      v-model="snackbar"
      :timeout="timeout"
    >
      <v-alert outlined type="error" prominent border="left">
        {{ alertText }}
      </v-alert>
    </v-snackbar>
    <v-dialog v-model="pdfDialog" width="90%" @click:outside="closePdf">
      <v-card style="position: relative; width: 100%; height: 90vh">
        <v-tooltip bottom>
          <template v-slot:activator="{ attrs, on }">
            <v-btn
              @click.prevent="closePdf"
              v-bind="attrs"
              v-on="on"
              text
              icon
              color="white"
              style="
                position: fixed;
                top: 10px;
                right: 10px;
                z-index: 3;
                filter: drop-shadow(1px 1px 1px white);
              "
            >
              <v-icon color="black">mdi-close</v-icon>
            </v-btn>
          </template>
          <span>Close</span>
        </v-tooltip>
        <div
          id="loader"
          class="d-flex justify-center align-center"
          style="position: absolute; top: 0; left: 0; width: 100%; height: 100%"
        >
          <v-progress-circular
            v-if="isPdfOpen && selectedPdf !== null"
            :rotate="-90"
            :size="150"
            :width="15"
            :value="value"
            color="black"
          >
            {{ value / 10 }}%
          </v-progress-circular>
        </div>
        <div v-if="showPdf" style="height: 100%; padding: 5px 0">
          <v-tooltip bottom>
            <template v-slot:activator="{ attrs, on }">
              <v-btn
                @click.prevent="closePdf"
                v-bind="attrs"
                v-on="on"
                text
                icon
                outlined
                color="white"
                style="position: fixed; top: 10px; right: 10px; z-index: 3"
              >
                <v-icon color="black">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Close</span>
          </v-tooltip>
          <vue-pdf-app
            v-if="selectedPdf !== null"
            @pages-rendered="pagesRendered"
            @open="openHandler"
            :pdf="selectedPdf"
            :file-name="detail.document_no"
          >
            <template #toolbar-sidebar-prepend="{ toggleTheme }">
              <button @click="toggleTheme = null" type="button">
                Toggle theme
              </button>
            </template>
          </vue-pdf-app>

          <div
            v-else
            class="d-flex justify-center align-center"
            style="
              height: 100%;
              width: 100%;
              margin-left: auto;
              position: relative;
              z-index: 1;
              background: #eaeaea;
            "
          >
            <h3 style="margin: 0">File Not Found</h3>
          </div>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog
      v-if="detail !== null"
      v-model="dokumenDialog"
      width="500"
      persistent
    >
      <v-card style="position: relative">
        <v-card-title class="text-h5 grey lighten-2">
          Dokumen Pendukung
        </v-card-title>
        <v-card-text class="d-flex justify-center align-center">
          <v-col md="12" style="padding: 0; position: relative; top: 20px">
            <v-data-table
              v-if="detail.file != null"
              mobile-breakpoint="0"
              fixed-header
              height="300"
              style="cursor: pointer"
              :headers="documentHeaders"
              :items="detail.file"
              @click:row="readyToDownload"
              hide-default-footer
            >
              <template v-slot:[`item.subject`]="{ item }">
                <div
                  style="
                    font-size: 12px;
                    padding: 0;
                    display: flex;
                    flex-direction: row;
                  "
                >
                  {{
                    item.subject !== null
                      ? item.subject !== ''
                        ? item.subject
                        : '-'
                      : '-'
                  }}
                </div>
              </template>
              <template v-slot:[`item.action`]="{ item }">
                <div
                  style="
                    font-size: 12px;
                    padding: 0;
                    display: flex;
                    flex-direction: row;
                  "
                >
                  <v-btn
                    icon
                    x-small
                    @click.stop="
                      unlinkDokumen(
                        item.file.slice(item.file.lastIndexOf('/') + 1)
                      )
                    "
                    style="margin-right: 5px"
                  >
                    <v-icon color="red">mdi-delete</v-icon>
                  </v-btn>
                  <v-btn icon x-small @click.stop="readyToDownload(item)">
                    <v-icon color="green">mdi-download</v-icon>
                  </v-btn>
                </div>
              </template>
            </v-data-table>

            <v-btn
              elevation="0"
              style="margin-right: auto; width: 100%"
              :loading="loading"
              color="primary"
              @click="uploadDoc('upload')"
            >
              <v-icon small style="margin-right: 5px">mdi-upload</v-icon>
              <span :style="`font-weight: bold; color:white;`"
                >Tambah Dokumen</span
              >
            </v-btn>
          </v-col>
        </v-card-text>
        <!-- <v-btn icon color="black" text @click="closeDokumenDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn> -->
        <v-divider></v-divider>

        <v-card-actions>
          <v-btn
            color="error"
            text
            outlined
            @click="closeDokumenDialog"
            :loading="loading"
          >
            Close
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            text
            outlined
            :loading="loading"
            @click="deleteAllFile"
          >
            Delete all File
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="rabDialog" width="500" persistent>
      <v-form
        :disabled="loading"
        lazy-validation
        ref="entryFormUpload"
        @submit.prevent="submitUploadDoc"
        style="position: relative"
      >
        <v-card>
          <v-card-title class="text-h5 grey lighten-2"> UPLOAD </v-card-title>

          <v-card-text class="d-flex justify-center align-center">
            <v-col md="12" style="padding: 0; position: relative; top: 20px">
              <div style="padding: 0 10px">
                <v-col cols="12" style="padding: 0">
                  <p
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Subject
                  </p>
                </v-col>
                <v-col cols="12" style="padding: 0">
                  <div>
                    <v-text-field
                      outlined
                      v-model="file_subject"
                      dense
                      :rules="rules.subjectRules"
                    ></v-text-field>
                  </div>
                  <div
                    style="padding: 10px; border: 2px dashed grey; height: 70px"
                  >
                    <v-file-input
                      ref="uploadDoc"
                      placeholder="Pilih File"
                      dense
                      append-icon="mdi-paperclip"
                      prepend-icon=""
                      @change="uploadFileDoc"
                      :rules="rules.docRules"
                    ></v-file-input>
                  </div>
                </v-col>
              </div>
            </v-col>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-btn
              id="closeFileUpload"
              color="error"
              text
              outlined
              type="reset"
              @click="uploadDoc('close')"
              :loading="loading"
            >
              close
            </v-btn>
            <v-spacer />
            <v-btn
              color="primary"
              text
              outlined
              type="submit"
              :loading="loading"
              :disabled="fileNameRab === '' || file_subject === ''"
            >
              simpan file
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <div
      v-if="loading"
      class="d-flex justify-center align-center"
      style="
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 5;
        background: rgba(0, 0, 0, 0.1);
      "
    >
      <v-progress-circular
        :size="100"
        color="primary"
        indeterminate
        class="d-flex justify-center align-center"
      >
        <p
          class="d-flex justify-center align-center"
          style="font-size: 12px; margin: auto"
        >
          Please wait
        </p>
      </v-progress-circular>
    </div>
  </v-container>
</template>
<script>
import 'vue-pdf-app/dist/icons/main.css'
import axios from 'axios'
import buildType from '../../../services/buildType'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import moment from 'moment'
const env = process.env.VUE_APP_BUILD_TYPE
export default {
  components: {
    FormItemGr: () => import('./ItemForm')
  },
  data() {
    return {
      pageKey: 0,
      config: require('../../../services/config.json')[env],
      wWidth: window.innerWidth,
      oAuth: buildType.apiURL('oauth'),
      proc: buildType.apiURL('proc'),
      upload: buildType.apiURL('upload2'),
      isLoadingPage: true,
      pagePath: this.$route.params.path,
      isGrPageEdit: false,
      userLevel: null,
      permission: null,
      isEdit: false,
      pdfDialog: false,
      dokumenDialog: false,
      closeDialog: false,
      rabDialog: false,

      checkbox: false,
      detail: null,
      searchItem: '',
      itemsAction: [],
      status: null,
      actionValue: 0,
      selectedData: [],
      loading: false,
      loader: null,
      fileNameRab: '',

      itemEdit: null,

      isAllow: false,
      matrix: [],
      rules: {},
      snackbar: false,
      alertText: '',
      timeout: 2000,
      value: 0,
      counter: 0,
      timer: 100,
      isPdfOpen: false,
      selectedPdf: null,
      showPdf: false,
      file_subject: '',

      selectedItem: null,
      options: {},
      tab: null,
      items: [{ tab: 'Detail Barang', content: '' }],
      act: 'add',
      itemDetail: null,
      pjcaList: [],
      dropdown: {
        vendor: []
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from
    })
  },
  computed: {
    ...mapGetters(['getUserProfile', 'getTabs']),
    grHeaders() {
      const arrHeaders = [
        // {
        //   text: 'No',
        //   value: 'no',
        //   align: 'left'
        //   // sortable: true,
        // },
        // {
        //   text: 'No. Payreq',
        //   value: 'payment_request',
        //   align: 'left'
        //   // sortable: false,
        // },
        {
          text: 'Kode Barang',
          value: 'product_code',
          align: 'left'
          // sortable: false,
        },
        {
          text: 'Nama Barang',
          value: 'product_name',
          align: 'left'
          // sortable: false,
        },
        // {
        //   text: 'Pembelian',
        //   value: 'qty_request',
        //   align: 'left'
        //   // sortable: false,
        // },
        // {
        //   text: 'Qty Return',
        //   value: 'return_qty',
        //   align: 'left',
        //   // sortable: true,
        //   sortable: false
        // },
        {
          text: 'Qty Diterima',
          value: 'qty_done',
          align: 'left',
          // sortable: true,
          sortable: false
        },
        {
          text: 'Satuan',
          value: 'uom_name',
          align: 'left',
          sortable: false
        },
        {
          text: 'Keterangan',
          value: 'description',
          align: 'left',
          sortable: false
        }
      ]
      // if (this.detail.status.id === 0) {
      return arrHeaders
      // }
    },

    documentHeaders() {
      return [
        {
          text: 'File Name',
          value: 'subject',
          align: 'left',
          sortable: false,
          width: '90%'
        },
        {
          text: 'Action',
          value: 'action',
          align: 'center',
          sortable: false,
          width: '10%'
        }
      ]
    }
  },
  watch: {
    selectedData() {
      this.itemsAction = [
        { id: 0, name: '' },
        { id: 1, name: 'Delete' }
      ]
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
    this.appLevel = this.config.application.ecatalogue.userLevel
    this.appLevel.administrator =
      this.config.application.all.userLevel.administrator
    this.getDataMenu()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    ...mapMutations([]),
    ...mapActions(['menu_access', 'getMenuId']),
    customSearch(value, search, item) {
      return Object.values(item).some(
        (v) => v && v.toString().toLowerCase().includes(search)
      )
    },
    showMsgDialog(
      pModalType,
      pStatusMsg,
      pBtnCancel,
      pInputType,
      pInputAtt,
      yesBtn,
      noBtn,
      pText
    ) {
      const title =
        pInputType === 'file'
          ? 'Upload bukti approvement pada kolom dibawah'
          : 'Tolong isi alasan pada kolom dibawah sebelum submit'

      let additional = ''
      if (pText !== undefined) {
        additional = '<span style="font-size:12px;">' + pText + '</span>'
      }
      return new Promise((resolve) => {
        this.$swal
          .fire({
            position: 'center',
            icon: pModalType,
            html:
              '<strong style="font-size:18px;">' +
              pStatusMsg +
              '</strong>' +
              '<br/>' +
              additional,
            showConfirmButton: true,
            showCancelButton: pBtnCancel,
            input: pInputType !== undefined ? pInputType : null,
            inputLabel: pInputType !== undefined ? title : null,
            // inputAttributes: pInputAtt !== undefined ? pInputAtt : null,
            confirmButtonText: yesBtn || 'Yes',
            cancelButtonText: noBtn || 'No'
          })
          .then((r) => {
            resolve(r)
          })
      })
    },
    async getDataMenu() {
      this.isLoadingPage = true
      const split = this.$route.path.split('/')
      const routeModule = '/' + split[1] + '/' + split[2]
      console.log('Path>>>>>', routeModule)
      await this.getMenuId({
        keyword: '',
        path: routeModule
      })
        .then((result) => {
          if (result.data.status_code === '00') {
            const menuId = result.data.data[0].id
            this.userLevel = this.getUserProfile.level.find(
              ({ application }) =>
                application.id === this.config.application.all.applicationId ||
                application.id ===
                  this.config.application.ecatalogue.applicationId
            )
            if (this.userLevel !== null) {
              this.checkMenuAccess([menuId, this.userLevel.id])
            } else {
              this.resetPermission(null)
            }
          } else {
            this.isLoadingPage = false
          }
        })
        .catch((err) => {
          console.log(err)
          this.isLoadingPage = false
        })
    },
    async checkMenuAccess(payload) {
      await this.menu_access(payload)
        .then((result) => {
          console.log('menuAccess>>>>', result)
          this.resetPermission(result)
        })
        .catch((err) => {
          console.log(err)
          this.resetPermission(null)
        })
    },
    resetPermission(val) {
      this.permission = null

      if (val !== null) {
        if (val.data !== null) {
          if (val.data.read_perm === 1) {
            this.permission = val.data
            this.initDataForLayout()
          }
        }
      }
      this.isLoadingPage = false
    },
    initDataForLayout() {
      this.isEdit = false

      this.loadPage()
    },
    nextPage() {
      this.loading = true
      try {
        const pageIndex = Number(this.$route.query.idx) + 1
        const path = `/e-catalogue/gr/${this.getGrList.grList[pageIndex].id}?idx=${pageIndex}`
        if (this.$route.path !== path) this.$router.push(path)
        setTimeout(() => {
          this.loadPage()
        }, 200)
      } catch (e) {
        this.loading = false
      }
    },
    previousPage() {
      this.loading = true
      try {
        const pageIndex = Number(this.$route.query.idx) - 1
        const path = `/e-catalogue/gr/${this.getGrList.grList[pageIndex].id}?idx=${pageIndex}`
        if (this.$route.path !== path) this.$router.push(path)
        setTimeout(() => {
          this.loadPage()
        }, 200)
      } catch (e) {
        this.loading = false
      }
    },
    async loadPage() {
      this.loading = true
      const url = `${this.proc}gr/detail/${this.$route.params.id}`
      await axios
        .get(url)
        .then((res) => {
          console.log('Detaill >>>', res)
          if (res.data.status_code == '00') {
            res.data.data.received_date = moment(
              res.data.data.received_date
            ).format('YYYY-MM-DD')
            this.detail = res.data.data
            if (res.data.data.status == 1) {
              // this.authorityCheck(res.data.data)
            }
            // this.dropdownDepartment()
            // this.dropdownShift()
          } else {
            this.showMsgDialog('error', res.data.status_msg, false)
          }
          this.loading = false
          return null
        })
        .catch((err) => {
          console.log(err)
          this.showMsgDialog(
            'error',
            err
              ? 'Something went wrong, Please contact an admin!'
              : 'Something went wrong, Please contact an admin!',
            false
          )
          this.loading = false
          return null
        })
    },
    async saveChange() {
      this.showMsgDialog('question', 'Simpan Perubahan', true).then(
        async (res) => {
          if (res.isConfirmed) {
            this.loading = true
            const form = {
              act: 'update',
              id: this.$route.params.id,
              received_by_name: this.detail.received_by_name,
              submitted_by_name: this.detail.submitted_by_name,
              received_date: this.detail.received_date,
              received_no: this.detail.received_no,
              po_no: this.detail.po_no,
              sj_no: this.detail.sj_no,
              form_no: this.detail.form_no
            }

            await axios
              .post(`${this.proc}gr/save`, form)
              .then((res) => {
                console.log(res.data)
                this.loading = false
                if (res.data.status_code == '00') {
                  this.loadPage()
                  this.showMsgDialog('success', res.data.status_msg, false)
                } else {
                  if (res.data.status_msg === 'Parameter value has problem') {
                    this.showMsgDialog(
                      'warning',
                      'Invalid input, Parameter value has problem',
                      false
                    )
                  } else {
                    this.showMsgDialog('warning', res.data.status_msg, false)
                  }
                }
                this.isEdit = false
              })
              .catch((err) => {
                console.log(err)
                this.loading = false
                this.isEdit = false
                this.showMsgDialog(
                  'error',
                  err
                    ? 'Something went wrong, Please contact an admin!'
                    : 'Something went wrong, Please contact an admin!',
                  false
                )
              })
          }
        }
      )
    },
    openDetailFpb(xData) {
      if (xData != null) {
        const arrItem = {
          list: []
        }
        this.$store.commit('setFpbList', arrItem)
        setTimeout(() => {
          window.open(`/e-catalogue/fpb-list/fpb/${xData.id}?idx=0`, '_blank')
          // this.$router.push(`/e-catalogue/fpb-list/fpb/${xData.id}?idx=0`)
        }, 200)
      }
    },
    openItemForm() {
      this.act = 'add'
      setTimeout(() => {
        document.getElementById('grItemForm').click()
      }, 300)
    },
    // initDropdown() {
    //   this.dropdownUnit()
    // },

    closePage() {
      this.detail = null
      const split = this.$route.path.split('/')
      const routeModule = '/' + split[1] + '/' + split[2]
      // this.$store.commit('setFpbId', null)
      // this.$router.push('/e-catalogue/' + this.$route.params.path)
      if (this.prevRoute !== undefined) {
        // if (this.prevRoute.path !== '/e-catalogue/cart') {
        // this.$router.push(this.prevRoute.path)
        // } else {
        this.$router.push(routeModule)
        // }
      } else {
        this.$router.push(routeModule)
      }
    },
    rowClick(pValue) {
      this.act = 'update'
      this.itemDetail = pValue
      setTimeout(() => {
        document.getElementById('grItemForm').click()
      }, 300)
    },
    editDetail() {
      this.isEdit = true
    },
    submitGr() {
      this.showMsgDialog(
        'warning',
        'Data tidak dapat dirubah bila sudah disubmit, lanjutkan ?',
        true,
        undefined,
        undefined,
        'Submit',
        'Batal',
        ''
      ).then(async (res) => {
        if (res.isConfirmed) {
          this.loading = true
          axios
            .post(`${this.proc}gr/submit`, { id: this.detail.id })
            .then(async (res) => {
              this.loading = false
              if (res.data.status_code == '00') {
                this.loadPage()
                this.showMsgDialog('success', res.data.status_msg, false)
              } else {
                if (res.data.status_msg === 'Parameter value has problem') {
                  this.showMsgDialog(
                    'warning',
                    'Invalid input, Parameter value has problem',
                    false
                  )
                } else {
                  this.showMsgDialog('warning', res.data.status_msg, false)
                }
              }
              // this.showMsgDialog('success', res.data.status_msg, false)
              // if (this.detail.approval_matrix !== null) {
              //   await this.fetch()
              //   console.log('fetch done')
              // } else {
              // }
            })
            .catch((err) => {
              this.loading = false
              this.showMsgDialog(
                'error',
                err
                  ? 'Something went wrong, Please contact an admin!'
                  : 'Something went wrong, Please contact an admin!',
                false
              )
            })
        }
      })
    },
    // confirmPayreq() {
    //   this.showMsgDialog(
    //     'question',
    //     'Approve payment request ?',
    //     true,
    //     undefined,
    //     undefined,
    //     'Confirm',
    //     'Batal',
    //     ''
    //   ).then((res) => {
    //     if (res.isConfirmed) {
    //       this.loading = true
    //       // const document_id = this.detail.approval_matrix[0].document_id
    //       axios
    //         .post(`${this.proc}payreq/confirm`, {
    //           document_id: this.detail.id
    //         })
    //         .then((res) => {
    //           this.loading = false
    //           if (res.data.status_code == '00') {
    //             this.loadPage()
    //             this.showMsgDialog('success', res.data.status_msg, false)
    //           } else {
    //             if (res.data.status_msg === 'Parameter value has problem') {
    //               this.showMsgDialog(
    //                 'warning',
    //                 'Invalid input, Parameter value has problem',
    //                 false
    //               )
    //             } else {
    //               this.showMsgDialog('warning', res.data.status_msg, false)
    //             }
    //           }
    //         })
    //         .catch((err) => {
    //           this.loading = false
    //           this.showMsgDialog(
    //             'error',
    //             err
    //               ? 'Something went wrong, Please contact an admin!'
    //               : 'Something went wrong, Please contact an admin!',
    //             false
    //           )
    //         })
    //     }
    //   })
    // },
    // rejectPayreq() {
    //   this.showMsgDialog(
    //     'question',
    //     'Reject payment request ?',
    //     true,
    //     undefined,
    //     undefined,
    //     'Reject',
    //     'Batal',
    //     ''
    //   ).then((res) => {
    //     if (res.isConfirmed) {
    //       this.loading = true
    //       // const document_id = this.detail.approval_matrix[0].document_id
    //       axios
    //         .post(`${this.proc}payreq/reject`, {
    //           document_id: this.detail.id
    //         })
    //         .then((res) => {
    //           this.loading = false

    //           if (res.data.status_code == '00') {
    //             this.loadPage()
    //             this.showMsgDialog('success', res.data.status_msg, false)
    //           } else {
    //             if (res.data.status_msg === 'Parameter value has problem') {
    //               this.showMsgDialog(
    //                 'warning',
    //                 'Invalid input, Parameter value has problem',
    //                 false
    //               )
    //             } else {
    //               this.showMsgDialog('warning', res.data.status_msg, false)
    //             }
    //           }
    //         })
    //         .catch((err) => {
    //           this.loading = false
    //           this.showMsgDialog(
    //             'error',
    //             err
    //               ? 'Something went wrong, Please contact an admin!'
    //               : 'Something went wrong, Please contact an admin!',
    //             false
    //           )
    //         })
    //     }
    //   })
    // },
    cancelGr() {
      this.showMsgDialog(
        'question',
        'Cancel Penerimaan ?',
        true,
        'textarea',
        undefined,
        'Cancel',
        'Batal',
        ''
      ).then((res) => {
        if (res.isConfirmed) {
          if (res.value != '') {
            this.loading = true
            const date = new Date()
            const local = date.toLocaleString('id')
            const updateAt = `[${local} - ${this.getUserProfile.employee.name}]\n${res.value}`
            axios
              .post(`${this.proc}gr/cancel`, {
                id: this.detail.id,
                cancel_reason: updateAt
              })
              .then((res) => {
                this.loading = false

                if (res.data.status_code == '00') {
                  this.loadPage()
                  this.showMsgDialog('success', res.data.status_msg, false)
                } else {
                  if (res.data.status_msg === 'Parameter value has problem') {
                    this.showMsgDialog(
                      'warning',
                      'Invalid input, Parameter value has problem',
                      false
                    )
                  } else {
                    this.showMsgDialog('warning', res.data.status_msg, false)
                  }
                }
              })
              .catch((err) => {
                this.loading = false
                this.showMsgDialog(
                  'error',
                  err
                    ? 'Something went wrong, Please contact an admin!'
                    : 'Something went wrong, Please contact an admin!',
                  false
                )
              })
          } else {
            this.showMsgDialog(
              'warning',
              'Kolom alasan tidak boleh kosong',
              false
            )
          }
        }
      })
    },
    setDraftGr() {
      this.showMsgDialog(
        'question',
        'Set to draft dokumen ?',
        true,
        undefined,
        undefined,
        'Simpan',
        'Batal',
        ''
      ).then((res) => {
        if (res.isConfirmed) {
          this.loading = true
          // const document_id = this.detail.approval_matrix[0].document_id
          axios
            .post(`${this.proc}gr/set_to_draft`, {
              id: this.detail.id
            })
            .then((res) => {
              this.loading = false

              if (res.data.status_code == '00') {
                this.loadPage()
                this.showMsgDialog('success', res.data.status_msg, false)
              } else {
                if (res.data.status_msg === 'Parameter value has problem') {
                  this.showMsgDialog(
                    'warning',
                    'Invalid input, Parameter value has problem',
                    false
                  )
                } else {
                  this.showMsgDialog('warning', res.data.status_msg, false)
                }
              }
            })
            .catch((err) => {
              this.loading = false
              this.showMsgDialog(
                'error',
                err
                  ? 'Something went wrong, Please contact an admin!'
                  : 'Something went wrong, Please contact an admin!',
                false
              )
            })
        }
      })
    },
    itemDelete(item, index) {
      console.log('this.selectedData', this.selectedData)
      this.showMsgDialog(
        'question',
        'Item tersebut akan dihapus, Anda yakin ?',
        true
      ).then((res) => {
        if (res.isConfirmed) {
          for (let i = 0; i < this.selectedData.length; i++) {
            axios
              .delete(`${this.proc}gr/delete_detail/${this.selectedData[i].id}`)
              .then((res) => {
                console.log('delete>>>>', res)
                if (i === this.selectedData.length - 1) {
                  if (res.data.status_code === '00') {
                    this.showMsgDialog('success', res.data.status_msg, false)
                  } else {
                    this.showMsgDialog('error', res.data.status_msg, false)
                  }
                  setTimeout(() => {
                    this.actionValue = 0
                    this.loadPage()
                  }, 200)
                }
              })
              .catch((err) => {
                if (i === this.selectedData.length - 1) {
                  this.showMsgDialog('error', err.message, false)
                  setTimeout(() => {
                    this.actionValue = 0
                  }, 200)
                }
              })
          }
        } else {
          this.actionValue = 0
        }
      })
    },
    actionSelect(event) {
      switch (event) {
        case 1:
          this.itemDelete()
          break
      }
    },
    statusName(val) {
      const arrType = ['DRAFT', 'DONE', 'CANCEL']
      return arrType[val]
    },
    statusColor(val) {
      const arrType = ['grey', 'green', 'red']
      return arrType[val]
    },
    convertDate(val) {
      const raw = val
      if (raw !== null) {
        const date = new Date(raw)
        const local = date.toLocaleString('id')
        return local
      }
    },

    generatePdfGr() {
      this.loader = 'loading'

      const l = this.loader
      this[l] = !this[l]
      setTimeout(() => {
        this[l] = false
        axios({
          url: `${this.proc}gr/export_to_pdf/${this.$route.params.id}`,
          method: 'GET',
          responseType: 'arraybuffer'
        })
          .then((res) => {
            this.selectedPdf = res.data
            setTimeout(() => {
              this.viewPDF()
            }, 1000)
          })
          .catch((error) => {
            console.log(error)
          })
      }, 2000)

      this.loader = null
    },
    viewPDF() {
      if (!this.isPdfOpen) {
        this.pdfDialog = true
        this.isPdfOpen = true
        // this.selectedPdf = 'true'
        // this.selectedPdf = pItem.file
        this.countDownTimer()
      }
    },
    countDownTimer() {
      if (this.counter < this.timer) {
        setTimeout(() => {
          this.counter += 1
          this.value += 10
          this.countDownTimer()
        }, 1)
      } else {
        this.showPdf = true
        this.value = 0
        this.counter = 0
      }
    },
    async openHandler(pdfApp) {
      this.info = []
      const info = await pdfApp.pdfDocument
        .getMetadata()
        .catch(console.error.bind(console))

      if (!info) return
      const props = Object.keys(info.info)
      props.forEach((prop) => {
        const obj = {
          name: prop,
          value: info.info[prop]
        }
        this.info.push(obj)
      })
    },
    pagesRendered(pdfApp) {
      setTimeout(() => (pdfApp.pdfViewer.currentScaleValue = 'page-actual'))
    },
    closePdf() {
      this.pdfDialog = false
      this.isPdfOpen = false
      this.showPdf = false
    },

    downloadDokumen() {
      // if (this.detail.file !== null) {
      //   if (this.detail.file.length > 0) {
      setTimeout(() => {
        this.dokumenDialog = true
      }, 300)
      //   } else {
      //     this.showMsgDialog('warning', 'Belum ada file yang diupload', false)
      //   }
      // } else {
      //   this.showMsgDialog('warning', 'Belum ada file yang diupload', false)
      // }
    },
    readyToDownload(fileLink) {
      window.open(fileLink.file, '_blank')
    },
    unlinkDokumen(fName, pValue) {
      this.loading = true
      const data = {
        module: 'gr',
        file_name: fName
      }
      axios
        .post(`${this.upload}esanqua/procurement/unlink`, data)
        .then((res) => {
          if (res.data.status_code === '00') {
            this.fileNameRab = ''
            if (pValue === undefined) {
              this.removeFileFromDetail(fName)
            }
          } else {
            this.showMsgDialog('warning', res.data.status_msg, false)
            if (pValue === undefined) {
              if (res.data.status_msg === 'File not found') {
                this.removeFileFromDetail(fName)
              }
            }
          }
          this.loading = false
        })
        .catch((err) => {
          this.loading = false
          this.showMsgDialog('error', err.message, false)
        })
    },
    removeFileFromDetail(fName) {
      for (let i = 0; i < this.detail.file.length; i++) {
        if (this.detail.file[i].file.includes(fName)) {
          this.detail.file.splice(i, 1)
        }
      }
      this.updatePhoto(false)
    },
    closeDokumenDialog() {
      setTimeout(() => {
        this.dokumenDialog = false
      }, 300)
    },

    uploadDoc(event) {
      if (event === 'upload') {
        setTimeout(() => {
          this.rabDialog = true
        }, 500)
      }
      if (event === 'close') {
        if (this.fileNameRab !== '') {
          let fName = ''
          fName = this.fileNameRab
          this.unlinkDokumen(fName, true)
          this.file_subject = null
          // this.$refs.uploadDoc.reset()
        }
        this.$refs.entryFormUpload.reset()
        setTimeout(() => {
          this.rabDialog = false
        }, 500)
      }
      this.fileNameRab = ''
    },
    uploadFileDoc(event) {
      if (event !== null) {
        if (event.size <= 1024 * 1024 * 2) {
          this.loading = true
          const data = new FormData()
          data.append('file', event)
          data.append('module', 'gr')
          axios
            .post(`${this.upload}esanqua/procurement`, data)
            .then((res) => {
              if (res.data.status === true) {
                this.showMsgDialog(
                  'success',
                  'File siap disimpan, Silahkan lanjutkan dengan klik tombol "simpan file"',
                  false
                )
                this.fileNameRab = res.data.data.name
                // setTimeout(() => {
                //   this.submitUploadDoc()
                // }, 200)
              } else {
                this.showMsgDialog('warning', res.data.message, false)
              }
              this.loading = false
            })
            .catch((err) => {
              this.loading = false
              this.showMsgDialog('error', err.message, false)
            })
        } else {
          setTimeout(() => {
            this.showMsgDialog('warning', 'Max size = 2MB', false)
            this.fileNameRab = ''
          }, 300)
        }
      } else {
        this.fileNameRab = ''
        // this.$refs.uploadDoc.reset()
      }
    },
    submitUploadDoc() {
      this.rules.docRules = [(v) => !!v || 'Tidak ada file yang terupload']
      this.rules.subjectRules = [(v) => !!v || 'Kolom Subject diperlukan']
      const self = this
      setTimeout(function () {
        if (self.$refs.entryFormUpload.validate()) {
          self.updatePhoto(true)
        }
      })
    },
    async updatePhoto(isAddFile) {
      this.loader = 'loading'

      const l = this.loader
      this[l] = !this[l]
      const file = []
      if (this.detail.file != null) {
        for (let i = 0; i < this.detail.file.length; i++) {
          const fName = this.detail.file[i].file.slice(
            this.detail.file[i].file.lastIndexOf('/') + 1
          )
          file.push({
            subject: this.detail.file[i].subject,
            file: fName
          })
        }
      }
      if (isAddFile) {
        file.push({
          subject: this.file_subject,
          file: this.fileNameRab
        })
      }
      const form = {
        id: this.$route.params.id,
        file: file
      }
      await axios
        .post(`${this.proc}gr/update_file_upload`, form)
        .then((res) => {
          this[l] = false
          if (res.data.status_code === '00') {
            this.showMsgDialog('success', 'File berhasil disimpan', false)
            this.file_subject = null
            this.fileNameRab = ''
            document.getElementById('closeFileUpload').click()
            this.loadPage()
          } else {
            this.showMsgDialog('error', res.data.status_msg, false)
            this.unlinkDokumen(this.fileNameRab)
          }
        })
        .catch((err) => {
          this.showMsgDialog('error', err.message, false)
          this[l] = false
          this.fileNameRab = ''
          this.$refs.entryFormUpload.reset()
        })
      this.loader = null
      this.isEdit = false
    },
    async deleteAllFile() {
      this.showMsgDialog(
        'question',
        'Semua file akan terhapus, Anda yakin ?',
        true
      ).then(async (res) => {
        if (res.isConfirmed) {
          this.loading = true
          const form = {
            id: this.$route.params.id,
            file: []
          }
          await axios
            .post(`${this.proc}gr/update_file_upload`, form)
            .then((res) => {
              if (res.data.status_code === '00') {
                this.showMsgDialog('success', res.data.status_msg, false)
                this.loadPage()
              } else {
                this.showMsgDialog('warning', res.data.status_msg, false)
              }
              this.loading = false
              setTimeout(() => {
                this.dokumenDialog = false
              }, 300)
            })
            .catch((err) => {
              this.loading = false
              this.showMsgDialog('error', err.message, false)
            })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.fpb-title {
  position: relative;
  top: 10px;
  margin: 0;
  // width: 50%;
  font-weight: bold;
  // text-align: center;
  font-size: 20px;
}
.items-total-div-2 {
  // padding: 10px 0;
  width: '40%';
  .items-total-box {
    border: 1px solid #e0e0e0;
    padding: 20px 10px;
    width: 400px;
    display: flex;
    margin-left: auto;
    flex-direction: column;
    justify-content: center;
    align-items: flex-end;
    font-size: 14px;
    div {
      border-bottom: 1px solid #e0e0e0;
      width: 100%;
      padding-top: 20px;
      display: flex;
      p {
        margin: 0;
        margin-right: 10px;
        min-width: 80px;
        position: relative;
        span {
          position: absolute;
          right: 0;
        }
      }
    }
  }
}
.items-total-div-3 {
  padding: 0 10px;
  width: 60%;
  font-size: 14px;
}
.actionButton {
  font-size: 14px;
  font-weight: bold;
  display: flex;
  align-items: center;
  margin-left: 15px;
}
.fpb-status-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
}
.category-line {
  margin: 10px 0 10px 0;
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  line-height: 75px;
}
@media (max-width: 1200px) {
  .category-line-item {
    margin-bottom: 10px;
  }
}
@media (max-width: 808px) {
  .actionButton {
    justify-content: center;
    align-items: flex-start;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: white;
    z-index: 2;
    padding: 10px 0;
  }
  .items-total-div-2 {
    width: '100%';
    .items-total-box {
      width: 100%;
    }
  }

  .items-total-div-3 {
    margin-top: 10px;
    width: 100%;
  }
  .tipe-proses {
    margin-top: 5px;
  }
}

@media (max-width: 840px) {
  .fpb-status-section {
    // flex-direction: column;
    flex-wrap: wrap;
  }
}
@media (max-width: 780px) {
  .fpb-title {
    font-size: 3vw;
  }
}
</style>
